import { Model } from 'app/model/backendmodel';
import { AdapterRegistry, SalesforceServiceCloudSink } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { ValueAdapter } from '../../value.adapter';
import { writeBehaviorOptionValues } from 'app/shared/constants/write-behavior.const';
import { CopySinkAdapter } from './copysink.adapter';
import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SalesforceServiceCloudSink),
    disabled: __IS_FABRIC_DPE__,
    asynchronous: true,
    adapts: {
        type: '*',
        writeBehavior: '*',
        writeBatchSize: '*',
        externalIdFieldName: '*',
        ignoreNullValues: '*',
        maxConcurrentConnections: '*'
    }
})
export class SalesforceServiceCloudSinkAdapter extends CopySinkAdapter<
    SalesforceServiceCloudSink,
    Model.SalesforceServiceCloudSink
> {
    protected override async _toResource(model: SalesforceServiceCloudSink): Promise<Model.SalesforceServiceCloudSink> {
        const result: Model.SalesforceServiceCloudSink = {
            type: 'SalesforceServiceCloudSink'
        };
        result.writeBatchSize = ValueAdapter.toResource(model, SalesforceServiceCloudSink.WRITE_BATCH_SIZE);
        result.writeBehavior = ValueAdapter.toResource(model, SalesforceServiceCloudSink.WRITE_BEHAVIOR);
        result.externalIdFieldName =
            model.writeBehavior &&
                typeof model.writeBehavior === 'string' &&
                model.writeBehavior.toLowerCase() === writeBehaviorOptionValues.insert
                ? undefined
                : ValueAdapter.toResource(model, SalesforceServiceCloudSink.EXTERNAL_ID_FIELD_NAME);
        result.ignoreNullValues = ValueAdapter.toResource(model, SalesforceServiceCloudSink.IGNORE_NULL_VALUES);
        CopySinkAdapter.maxConcurrentConnectionsToResource(model, result);
        CopySinkAdapter.toCommonCopySinkResource(model, result, this.context);
        return result;
    }

    protected override async _toModel(
        resource: Model.SalesforceServiceCloudSink,
        owner: Activity
    ): Promise<SalesforceServiceCloudSink> {
        const result = Owned.create<SalesforceServiceCloudSink>(Metamodel.modelFor(SalesforceServiceCloudSink), owner);
        ValueAdapter.toModel(result, SalesforceServiceCloudSink.WRITE_BATCH_SIZE, resource.writeBatchSize);
        ValueAdapter.toModel(result, SalesforceServiceCloudSink.EXTERNAL_ID_FIELD_NAME, resource.externalIdFieldName);
        ValueAdapter.toModel(result, SalesforceServiceCloudSink.IGNORE_NULL_VALUES, resource.ignoreNullValues);

        // handle upper case and lower case
        let writeBehavior = resource.writeBehavior;
        if (writeBehavior && typeof writeBehavior === 'string') {
            const lowerCaseValue = writeBehavior.toLowerCase();
            switch (lowerCaseValue) {
                case writeBehaviorOptionValues.insert:
                    writeBehavior = writeBehaviorOptionValues.insert;
                    break;
                case writeBehaviorOptionValues.upsert:
                    writeBehavior = writeBehaviorOptionValues.upsert;
                    break;
                default:
                    break;
            }
        }
        ValueAdapter.toModel(result, SalesforceServiceCloudSink.WRITE_BEHAVIOR, writeBehavior);

        CopySinkAdapter.maxConcurrentConnectionsToModel(resource, result);
        CopySinkAdapter.toCommonCopySinkModel(result, resource);
        return result;
    }
}
